var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighligh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91756 12.7408L17.6655 7.35064L18.8449 8.64655L12.7509 15.854L9.91756 12.7408ZM7.58746 13.152L12.1228 18.1353C12.2167 18.2283 12.3292 18.3003 12.453 18.3466C12.5768 18.3929 12.709 18.4123 12.8409 18.4038C12.9728 18.3952 13.1013 18.3587 13.2181 18.2967C13.3348 18.2348 13.4371 18.1488 13.5181 18.0444L20.9695 9.23139C21.1179 9.06827 21.202 8.85672 21.2059 8.6362C21.2098 8.41569 21.1333 8.20128 20.9908 8.03299L18.4778 5.27183C18.3236 5.1141 18.1174 5.01786 17.8975 5.00105C17.6775 4.98425 17.459 5.04804 17.2827 5.18051L7.80905 11.7713C7.69748 11.8422 7.60223 11.9359 7.52958 12.0463C7.45693 12.1567 7.40853 12.2813 7.38759 12.4118C7.36664 12.5423 7.37363 12.6757 7.40808 12.8033C7.44254 12.9309 7.50367 13.0498 7.58746 13.152ZM2.79395 19.0277L8.4113 20L9.89044 18.6538L6.86155 15.3258L2.79395 19.0277Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighligh);
export default __webpack_public_path__ + "static/media/highligh.b49b97531e4e62cf8b236bf7cde8d115.svg";
export { ForwardRef as ReactComponent };